const apiCall = async (
  endpoint,
  method = 'POST',
  payload,
  msgConfig = {},
  fetchCart = true,
  awaitFetchCart = false,
) => {
  try {
    const response = await fetch(endpoint, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: payload ? JSON.stringify(payload) : null,
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error(`Cart API error in ${msgConfig.action}:`, errorData);
      alert(errorData.message || msgConfig.error);
      return;
    }

    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { itemCount: cartData.item_count },
      }),
    );

    // Refresh the cart
    if (fetchCart && awaitFetchCart) {
      await window.CartDrawer?.fetch?.();
    } else if (fetchCart) {
      window.CartDrawer?.fetch?.();
    }
  } catch (error) {
    console.error(`Cart error in ${msgConfig.action}:`, error);
    alert('An unexpected error occurred. Please try again.');
  }
};

export const cartApi = {
  updateQty: (itemKey, quantity, action, setLoading) => {
    setLoading({ status: true, itemKey, action });

    const payload = { id: String(itemKey), quantity: quantity };
    const msgConfig = {
      action: 'updateQty',
      error: 'An error occurred while updating the cart.',
    };
    apiCall('/cart/change.js', 'POST', payload, msgConfig, true, true).finally(
      () => {
        setLoading(null);
      },
    );
  },

  addToCart: (variantId, quantity = 1, action, setLoading) => {
    setLoading({ status: true, variantId, action });

    const payload = { id: String(variantId), quantity: quantity };
    const msgConfig = {
      action: 'addToCart',
      error: 'An error occurred while adding the product to the cart.',
    };
    apiCall('/cart/add.js', 'POST', payload, msgConfig, true, true).finally(
      () => {
        setLoading(null);
      },
    );
  },
};

export const fetchVariantMetafields = async (variantIds) => {
  const query = `
    query getVariantMetafields($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          limitMessage: metafield(namespace: "custom", key: "limit_message") {
            value
          }
          maxLimit: metafield(namespace: "custom", key: "quantity_limit") {
            value
          }
        }
      }
    }
  `;

  const variantGIDs = variantIds.map(
    (id) => `gid://shopify/ProductVariant/${id}`,
  );

  try {
    const response = await fetch(
      `https://${Shopify.shop}/api/2023-07/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': window.STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({
          query,
          variables: { ids: variantGIDs },
        }),
      },
    );

    const json = await response.json();

    if (json.errors) {
      console.error('GraphQL errors:', json.errors);
      return [];
    }

    if (!json.data || !json.data.nodes) {
      console.error('Unexpected GraphQL response:', json);
      return [];
    }

    // Transform the response to a more usable format
    return json.data.nodes.map((node) => ({
      id: node.id,
      maxLimit: node.maxLimit ? parseInt(node.maxLimit.value) || 0 : 0,
      limitMessage: node.limitMessage ? node.limitMessage.value || '' : '',
    }));
  } catch (error) {
    console.error('Network error:', error);
    return [];
  }
};
